import { APIClient } from "helpers/api_helper";

const api = new APIClient();

export async function getTickets() {
  try {
    const response = await api.get("merchant/all/tickets", null);
    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error("Tickets could not be loaded");
  }
}

export async function getTicketList(slotId) {
  try {
    const response = await api.get(`merchant/tickets/${slotId}`, null);
    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error("Tickets could not be loaded");
  }
}

export async function getTicketPerGameSlotList(
  gameSlotId,
  page,
  size,
  ticketId,
  phoneNumber,
  createdAt
) {
  try {
    const response = await api.get(
      `merchant/tickets/${gameSlotId}?page=${page}&size=${size}&ticketId=${ticketId}&phoneNumber=${phoneNumber}&createdAt=${createdAt}`,
      null
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error("Tickets could not be loaded");
  }
}
